module.exports = __webpack_public_path__ + "img/orb_of_venom.be623571.png";